import { Controller } from "@hotwired/stimulus"
import * as bootstrap from 'bootstrap'

export default class extends Controller {
  static targets = ['deleteModal', 'deleteSeasonName']

  connect() {
    this.deleteUrl = ''
    this.seasonName = ''
    this.rowToDelete = null
    this.deleteModal = new bootstrap.Modal(this.deleteModalTarget)
  }

  showDeleteModal(event) {
    event.preventDefault()
    
    const deleteUrl = event.currentTarget.dataset.deleteUrl
    const seasonName = event.currentTarget.dataset.seasonName
    
    this.deleteUrl = deleteUrl
    this.seasonName = seasonName
    
    // Set season name in modal
    this.deleteSeasonNameTarget.textContent = seasonName
    
    // Show confirmation modal
    this.deleteModal.show()
  }

  confirmDelete() {
    // Hide confirmation modal
    this.deleteModal.hide()
    
    // Check if TOTP verification is needed
    const currentAdminHasTotp = this.element.dataset.currentAdminTotpEnabled === 'true'
    
    if (currentAdminHasTotp) {
      this.showTotpModal()
    } else {
      this.sendDeleteRequest()
    }
  }

  sendDeleteRequest() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    
    fetch(this.deleteUrl, {
      method: 'DELETE',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Accept': 'application/json'
      }
    })
    .then(response => {
      if (response.ok) {
        // Reload page to show updated season list
        window.location.reload()
      } else {
        throw new Error('Delete failed')
      }
    })
    .catch(error => {
      console.error('Error:', error)
      alert(error.message || 'Delete failed')
    })
  }

  showTotpModal() {
    // Dispatch custom event to reusable TOTP modal
    const event = new CustomEvent('showTotpModal', {
      detail: {
        actionUrl: this.deleteUrl,
        actionMethod: 'DELETE',
        formData: {},
        rowToDelete: this.rowToDelete,
        dataTable: null,
        redirectUrl: null // Reload page instead of redirect
      }
    })
    document.dispatchEvent(event)
  }
} 